import Swal from "sweetalert2"
import faradayApi from "../../api/faradayApi"


export const createDivestment = async (formValues, succesMsg, errorMsg) => {
    try {
        const { data } = await faradayApi.post('/divestment', formValues)

        if (data.ok === true) {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        await Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}

export const editDivestment = async (formValues, succesMsg, errorMsg) => {
    try {
        const { data } = await faradayApi.put('/divestment', formValues)

        if (data.ok=== true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false

    }
}

export const createAllDivest = async (formValues, succesMsg, errorMsg) => {
    try {
        const { data } = await faradayApi.post('/divestment/allDivestment', formValues)

        if (data.ok === true) {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        await Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}